function recursiveParse(info) {
  let result = info;
  while (result && typeof result === 'string') {
    result = JSON.parse(result);
  }
  return result;
}

export default recursiveParse;
